import React from "react";
import "./NotFound.css";
import { Link } from "react-router-dom";

const NotFound = () => (
  <div id="notfound">
    <div className="notfound">
      <div className="notfound-404">
        <h1>404</h1>
      </div>
      <h2>Žao nam je, stranica nije pronađena!</h2>
      <p>
        Stranica koju tražite je možda uklonjena, promenila naziv ili je
        privremeno nedostupna
      </p>
      <Link to="/dashboard">Nazad na početnu stranu</Link>
    </div>
  </div>
);

export default NotFound;
